module.exports = __webpack_public_path__ + "img/hero.163c4805.png";